import React from "react";
import { Image } from "semantic-ui-react";
import { resolveImage } from "config/app.helpers";

export default class OptionPicture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
        };
    }

    setHover = () => this.setState({ hovered: true });
    removeHover = () => this.setState({ hovered: false });

    render() {
        let componentStyles = {
            default: {
                width: "100%",
                transform: `scale(${this.state.hovered ? 1.1 : 1})`,
                cursor: "pointer",
                zIndex: this.state.hovered ? 1 : 0,
            },
            grid: {
                width: "48%",
                padding: "1%",
                transform: `scale(${this.state.hovered ? 1.1 : 1})`,
                cursor: "pointer",
                zIndex: this.state.hovered ? 1 : 0,
                display: "inline-block",
            },
        };

        return (
            <Image
                src={resolveImage(this.props.image, this.props.imageLibrary)}
                alt="imageGroup"
                style={componentStyles[this.props.layout]}
                onMouseEnter={this.setHover}
                onMouseLeave={this.removeHover}
                onClick={() => this.props.handleClick(this.props.index)}
            />
        );
    }
}
